<template>
  <el-card class="card-main">
    <el-form :model="searchForm" :inline="true" class="global-form">
      <el-form-item prop="title">
        <el-input v-model="searchForm.fileName" placeholder="请输入文件名称" clearable></el-input>
      </el-form-item>
      <el-form-item prop="date">
        <el-date-picker
          v-model="date"
          type="daterange"
          @change="changeDate"
          value-format="yyyy-MM-dd"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="state">
        <el-select clearable v-model="searchForm.status" placeholder="请选择状态">
          <el-option v-for="(item, index) of stateList" :key="index" :label="item" :value="index+1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loadData">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="文件名称" show-overflow-tooltip prop="fileName"></el-table-column>
      <el-table-column label="文件状态" show-overflow-tooltip>
        <template v-slot="{row}">
          {{[1, 2, 3].includes(row.status) ? stateList[row.status - 1] : '生成失败'}}
        </template>
      </el-table-column>
      <el-table-column label="生成时间" show-overflow-tooltip>
        <template v-slot="{row}">
          {{row.updateTime || '--'}}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200px">
        <template v-slot="{row}">
          <template v-if="row.status !== 1">
            <el-button type="text" @click="toDownload(row.url)" v-if="row.status !== 3" v-show="$ButtonShow('download')">下载</el-button>
            <!-- <el-button type="text" v-if="row.status === 3">重新生成</el-button> -->
            <el-button type="text" v-show="$ButtonShow('EXP_DEL_01')" @click="onDelete(row.id)">删除</el-button>
          </template>
          <template v-else>--</template>
        </template>
      </el-table-column>
    </el-table>
    <global-pagination
      @size-change="loadData"
      @current-change="loadData"
      :current-page.sync="page"
      :page-size.sync="size"
      :total="total">
    </global-pagination>
  </el-card>
</template>

<script>
export default {
  name: 'PatrolExport',
  data () {
    return {
      searchForm: {
        fileName: '',
        startTime: '',
        endTime: '',
        status: ''
      },

      stateList: ['生成中', '已生成', '生成失败'],
      loading: false,
      date: [],
      tableData: [],

      page: 1,
      size: 10,
      total: 0,

      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        }
      }
    }
  },

  created () {
    this.loadData()
  },
  methods: {
    changeDate (date) {
      this.searchForm.startTime = (date && this.$dayjs(date[0]).format('YYYY-MM-DD')) || ''
      this.searchForm.endTime = (date && this.$dayjs(date[1]).format('YYYY-MM-DD')) || ''
    },

    loadData () {
      this.$axios.get(this.$apis.patrol.selectExportByList, {
        size: this.size,
        page: this.page,
        ...this.searchForm
      }).then(res => {
        this.total = res.total || 0
        this.tableData = res.list || []
      })
    },

    toDownload (url) {
      window.open(url)
    },

    onDelete (id) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.patrol.deleteExport, {
          id
        }).then(() => {
        // console.log('删除成功id', id)
          this.loadData()
        })
      })
    }
  }

}
</script>

<style scoped lang="scss">

</style>
